export const soilsTranslationsRo = {
  'soils.validation.min': 'Trebuie să fie mai mare decât 0',
  'soils.validation.max': 'Trebuie să fie mai mic decât 1',
  'soils.validation.rfu_ru': 'Acest câmp este obligatoriu',
  'soils.edit.rfu.error': 'Valoare invalidă',
  'soils.table.rfu_ru': 'RFU/RU',
  'arvalis.modal.title': 'Configurați-vă RFU/TAW cu ajutorul ARVALIS',
  'arvalis.modal.button.label': 'Simulator ARVALIS',
  'soil.arvalis-modal.button.label': 'Cum să îmi configurez solul dacă nu am o analiză completă?',
  'arvalis.modal.text1':
    'Nu știi exact RFU/TAW? Apasă pe simulatorul dezvoltat de ARVALIS care te va ajuta să îl defini pe baza unor criterii. Acest lucru îți va permite să îmbunătățești încrederea în recomandările de irigație ale Pixagri pe tot parcursul sezonului.',
  'arvalis.modal.text2':
    'Apoi introdu valoarea RU și raportul RAW/TAW când creezi solul. Asigură-te și că selectezi textura cea mai apropiată de solul tău.',
};
